import type orderId from "./id";

const orderEn: typeof orderId = {
	order: {
		title: "Order Category",
		subtitle: "Summary of list of order categories",
		label: "Order",
		empty_state: {
			title: "No order categories yet",
			description: "Please add a new order category.",
		},
		table: {
			title: "Order Category Data",
			columns: {
				date: "Date",
				category: "Category",
				discount: "Discount",
				status: "Status",
			},
		},
		status: {
			active: "Active",
			inactive: "Inactive",
		},
		forms: {
			add: {
				button: "Add Order Category",
				title: "Add Order Category",
				fields: {
					category: {
						label: "Category",
						placeholder: "Category name",
					},
					discount: {
						label: "Discount",
						placeholder: "Discount",
					},
				},
				toast: {
					success: {
						title: "Success!",
						description: "New order category added successfully!",
					},
					error: {
						title: "An Error Occurred",
						description: "Please try again in a few moments!",
					},
				},
			},
			edit: {
				title: "Edit Order Category",
				info: "Order category information",
				fields: {
					category: {
						label: "Category",
						placeholder: "category",
					},
					discount: {
						label: "Discount",
						placeholder: "discount",
					},
				},
			},
			delete: {
				title: "Delete Order Category",
				description: "Are you sure you want to delete {name}?",
			},
		},
		actions: {
			cancel: "Cancel",
			save: "Save",
			save_changes: "Save Changes",
			saving_changes: "Saving...",
			delete: "Delete",
		},
	},
};

export default orderEn;
